<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class>
          <v-card-title class="subheading">
            Preguntas frecuentes
            <v-spacer></v-spacer>
            <v-text-field
              flat
              hide-details
              prepend-inner-icon="search"
              label="Buscar en las preguntas frecuentes"
              class="ml-4"
              v-model="valueFieldSearch"
            ></v-text-field>
          </v-card-title>
          <v-expansion-panels popout focusable>
            <v-expansion-panel v-for="(item,index) in dataFiltered" :key="index">
              <v-expansion-panel-header>{{ item.Pregunta }}</v-expansion-panel-header>
              <v-expansion-panel-content class="pa-3 pt-5">
                <div v-html="item.Respuesta"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import globalService from "@/services/globalService.js";

export default {
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Faqs", href: "/faqs" }
    ]);
  },
  mounted() {
    var that = this;
    globalService.getFaqs().then(res => {
      that.dataFaqs = res;
      if (!!that.dataFaqs && [that.dataFaqs.length > 0]){
        const regex = /@@soporte-correo@@/gi
        that.dataFaqs.forEach(item => {
          item.Respuesta = item.Respuesta.replace(regex, that.soporteCorreo);
        });
      }
    });
  },
  props: {
    isPublic: {
      type: String,
      defualt: "false"
    }
  },
  data() {
    return {
      valueFieldSearch: "",
      dataFaqs: []
    };
  },
  computed: {
    ...mapState("global", ["soporteCorreo"]),
    dataFiltered: function() {
      if (!!this.valueFieldSearch) {
        var self = this;
        return self.dataFaqs.filter(function(post) {
          return (
            post.Pregunta.toUpperCase().indexOf(
              self.valueFieldSearch.toUpperCase()
            ) !== -1 ||
            post.Respuesta.toUpperCase().indexOf(
              self.valueFieldSearch.toUpperCase()
            ) !== -1
          );
        });
      } else {
        return this.dataFaqs;
      }
    }
  }
};
</script>
<style scoped>
.container.container--fluid
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #1565c0 !important;
  color: #fff;
}
</style>